<template>
  <article class="notification-card" :class="{ 'unread': !notification.read }" @click.stop="routeFor(notification)">
    <div class="notification-card--dot-indicator"></div>
    <div class="notification-card--content">
      <div class="notification-card--content-header">
        <h3 class="notification-card--content-header-title">{{setupTitleForType(notification.type)}}</h3>
        <span class="notification-card--content-header-time">{{new Date(notification.creationDate).toLocaleDateString()}}</span>
      </div>
      <p class="notification-card--content-text">{{notification.text}}</p>
    </div>
  </article>
</template>

<script>
    import { ProductServiceMixim } from '@/mixims/ProductServiceMixim.js'
    export default {
      name: 'NotificationsTimeCard',
      mixins: [ProductServiceMixim],
      data () {
        return {
        }
      },
      props: ['notification'],
      methods: {
        routeFor (notification) {
          if (!notification.read) this.markLikeReaded(notification.id)
          // intenta rutear
          if (
            notification.text.includes('pedido:') ||
            notification.text.includes('Promocion:') ||
            notification.text.includes('Incidencia:') ||
            notification.text.includes('Incidencia cerrada:') ||
            notification.text.includes('devolución:') ||
            notification.text.includes('devuelto:')
          ) {
            this.routeTo(notification)
            return
          }
          if (notification.text.includes('sku:') || notification.text.includes('producto:')) {
            this.routeToSku(notification)
            return
          }
          // fallback: si no hay ruta, al menos cierra el dropdown
          this.$emit('hideNotify')
        },
        markLikeReaded (id) {
          this.$emit('markRead', id)
        },
        setupTitleForType (value) {
          switch (value) {
            case 'CHANGE_ORDER_STATE_HANDLER':
              return this.$t('Cambio de estado de pedido')
            case 'LOW_SKU_INVENTARY':
              return this.$t('Inventario de sku bajo')
            case 'COMMERCIAL_CONDITION_COMMISSION':
              return this.$t('Comercial')
            case 'CREATE_NEW_CONTROVERSY':
              return this.$t('Controversia')
            case 'CREATE_NEW_INCIDENCE':
              return this.$t('Incidencia')
            case 'CHANGE_ORDER_STATE_RETURN':
              return this.$t('Devolución')
            case 'CHANGE_ORDER_STATE_PARTIAL_RETURN':
              return this.$t('Devolución parcial')
          }
        },
        routeTo (reference) {
          let route = ''
          if (reference.text.indexOf('pedido:') !== -1) route = `/orders/orderDetail/${reference.reference}`
          if (reference.text.indexOf('producto:') !== -1) route = `/catalog/details/${reference.reference}`
          if (reference.text.indexOf('Incidencia:') !== -1) route = `/incidents/list?ref=${reference.reference}`
          if (reference.text.indexOf('Incidencia cerrada:') !== -1) route = `/incidents/list?ref=${reference.reference}`
          if (reference.text.indexOf('devolución:') !== -1) route = `/orders/orderDetail/${reference.reference}`
          if (reference.text.indexOf('devuelto:') !== -1) route = `/orders/orderDetail/${reference.reference}`
          if (reference.text.indexOf('Promocion:') !== -1) {
            this.routeToPromo(reference)
            return
          }
          if (!reference.read) this.markLikeReaded(reference.id)
          this.$router.push({path: route}).catch(() => {})
          this.$emit('hideNotify')
        },
        routeToSku (reference) {
          if (reference.text.indexOf('sku:') !== -1 || reference.text.indexOf('producto:') !== -1) {
            let filter = {
              sku: {desde: null, hasta: null},
              upc: {desde: null, hasta: null},
              fecha: {desde: null, hasta: null},
              category: {id: null, text: null},
              fromQuantity: null,
              toQuantity: null,
              account: null,
              text: reference.reference
            }
            let tableFilterInfo = {currentPage: 1, perPage: 2}
            this.getProducts(tableFilterInfo, filter).then(
              (response) => {
                if (response.body && response.body[0] && response.body[0].id) {
                  if (!reference.read) this.markLikeReaded(reference.id)
                  this.$router.push({
                    path: `/catalog/details/${response.body[0].id}`,
                    query: {
                      sku: reference.reference
                    }
                  }).catch(() => {})
                  this.$emit('hideNotify')
                }
              },
              (error) => {
                console.log(error)
                return []
              }
            )
          }
        },
        routeToPromo (reference) {
          if (!reference.read) this.markLikeReaded(reference.id)
          this.$router.push({path: `/catalog/promotions`, query: { promo: reference.reference }}).catch(() => {})
          this.$emit('hideNotify')
        }
      }
    }
</script>

<style lang="scss">
    @import './_notifiVars.scss';
    @import 'scss/_bootstrap-variables.scss';

    .notification-card {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 15px;
      margin: 0;
      border-bottom: solid 1px $gray-200;
      cursor: pointer;

      &.unread {
        background-color: lighten($local-header-color, 67%);
      }

      &:hover {
        background-color: lighten($local-header-color, 64%);
      }

      &--dot-indicator {
        width: 6px;
        height: 6px;
        background-color: $gray-200;
        border-radius: 100%;
        margin-right: 15px;

        .unread & {
          background-color: $bag-notification-color;
        }
      }

      &--content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;

        &-header {
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          &-title {
            margin: 0;
            font-size: 14px;
            color: $gray-800;

          }
          &-time {
            font-size: 10px;
            color: $gray-600;
          }
        }


        &-text {
          margin: 0;
          font-size: 12px;
          color: $gray-600;
        }
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/Header/Notifications/Notification__timeCard.vue